
import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const LeadCapture = lazy(() => import("@/pages/LeadCapture/LeadCapture"));
const LeadForms = lazy(() => import("@/pages/LeadCapture/LeadForms"));
const LeadSubmission = lazy(() => import("@/pages/LeadCapture/LeadSubmission"));
const CreateForm = lazy(() => import("@/pages/LeadCapture/CreateForm/CreateForm"));
const EmbedCode = lazy(() => import("@/pages/LeadCapture/EmbedCode/EmbedCode"));
const LeadFormRenderer = lazy(() => import("@/pages/LeadCapture/EmbedCode/LeadFormRenderer"));

const LeadCaptureRoute: RouteConfig = {
    path: "",
    element: <LeadCapture />,
    pageName: "Lead Capture",
    sidebar: {
        show: true,
        icon: "/assets/media/customerLogo.svg"
    },
    children: {
        MAIN: {
            path: "lead-forms",
            element: <LeadForms />,
            pageName: "Lead Forms",
            sidebar: { show: true, icon: "" },
            permission: ["LeadMagnetFormView"],
        },
        LEAD_SUBMISSION: {
            path: "lead-submission/:formCode",
            element: <LeadSubmission />,
            pageName: "Lead Submission",
            sidebar: { show: false, icon: "" },
            permission: ["LeadMagnetFormView"],
        },
        LEAD_FORM: {
            path: "create-form",
            element: <CreateForm />,
            pageName: "Create Form",
            sidebar: { show: true, icon: "" },
            permission: ["LeadMagnetFormAdd"],
        },
        EMBED_CODE: {
            path: "embed-code/:formCode",
            element: <EmbedCode />,
            pageName: "Embed Code",
            sidebar: { show: false, icon: "" },
        },
        EMBED_FORM: {
            path: "embed/:formCode",
            element: <LeadFormRenderer />,
            pageName: "Lead Form",
            sidebar: { show: false, icon: "" },
        },
    }
}
export default LeadCaptureRoute;